import { render, staticRenderFns } from "./page-layout-grid-space.vue?vue&type=template&id=6507abb0&scoped=true"
import script from "./page-layout-grid-space.vue?vue&type=script&lang=js"
export * from "./page-layout-grid-space.vue?vue&type=script&lang=js"
import style0 from "./page-layout-grid-space.vue?vue&type=style&index=0&id=6507abb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507abb0",
  null
  
)

export default component.exports